<template>
  <v-list-tile>
    <v-list-tile-action>
      <v-icon>account_balance</v-icon>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title class="font-weight-medium">
        Pagamento DARF
        <v-icon small>help_outline</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="partner === 'establishment'">
        Pague seus DARFs (Documento de Arrecadação de Receitas Federais) direto da sua conta digital
        {{ account.fantasy_name }}.
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-else>
        Pague seus DARFs (Documento de Arrecadação de Receitas Federais) direto da sua conta digital
        {{ partnerName }}.
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <v-btn outline color="indigo" @click="newDarfPaymentForm">&nbsp;Realizar Pagamento&nbsp;</v-btn>
    </v-list-tile-action>
    <new-darf-payment-form />
  </v-list-tile>
</template>
<script>
import { EventBus } from "@/services/event-bus";
import { mapGetters } from 'vuex';
export default {
  name: "NewDarfPayment",
  created() {
    this.$store.dispatch('account/getAccount');
  },
   computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
      darfErrors: "bills/darfPaymentError"
    }),
    paymentProvider() {
      return (this.account && this.account.bill_source) || 'banco_inter';
    }
  },
  components: {
    newDarfPaymentForm: () =>
      import(
        "@/components/desktop/bills/actions/NewDarfPaymentForm.vue"
      )
  },
  methods: {
    newDarfPaymentForm() {
      EventBus.$emit("show-new-darf-payment-form");
    }
  }
};
</script>